// extracted by mini-css-extract-plugin
module.exports = {"productImage":"UwyFnz","productBadge":"w5jrt4","badge":"FeRUNQ","defaultImage":"m4NVI6"};